"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var CardHelper = __importStar(require("./A_CardHelper"));
var CardGroup = __importStar(require("./A_CardGroup"));
var ConfigProductCard = __importStar(require("./A_ConfigProductCard"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var ProgressGroupWithParagraph = __importStar(require("./O_ProgressGroupWithParagraph"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Component = function (p) {
    var compatible = p.products.filter(function (product) { return !!product.compatible; });
    var incompatible = p.products.filter(function (product) { return !product.compatible; });
    return p.loading ? (Preact.h(Box_1.default, { height: "100%", display: "flex", flexDirection: "column", sx: {
            justifyContent: { md: 'center' },
            paddingX: '16px',
            paddingY: { xs: '16px', md: '0px' },
        } },
        Preact.h(ProgressGroupWithParagraph.Component, { paragraph: p.loadingText, statusText: p.statusText }))) : (Preact.h(CardGroup.Component, null,
        compatible.map(function (c) { return (Preact.h(WatchVisibility, { onBecomeVisible: function () {
                p.onBecomeVisible(c.propertyValue);
            } },
            Preact.h(ListItemButton_1.default, { sx: {
                    width: 'min-content',
                    borderRadius: '8px',
                    flexGrow: 0,
                    padding: '0px',
                }, autoFocus: c.active, onClick: function () { return p.onSelectOption(c.propertyValue); }, "data-testId": c.active ? undefined : 'option-btn' },
                Preact.h(ConfigProductCard.Component, __assign({}, c, { nullOptionText: p.nullOptionText }))))); }),
        incompatible.length > 0 && (Preact.h(ListItem_1.default, { disableGutters: true, disablePadding: true, sx: { width: 'auto' } },
            Preact.h(CardHelper.Component, { helperText: p.helperText }))),
        incompatible.map(function (i) { return (Preact.h(WatchVisibility, { onBecomeVisible: function () {
                p.onBecomeVisible(i.propertyValue);
            } },
            Preact.h(ListItemButton_1.default, { sx: {
                    width: 'min-content',
                    borderRadius: '8px',
                    flexGrow: 0,
                    padding: '0px',
                }, onClick: function () { return p.onSelectOption(i.propertyValue); } },
                Preact.h(ConfigProductCard.Component, __assign({}, i, { nullOptionText: p.nullOptionText }))))); })));
};
exports.Component = Component;
var WatchVisibility = function (p) {
    var _a = useVisibility(), visible = _a.visible, updateRef = _a.updateRef;
    Hooks.useEffect(function () {
        if (visible) {
            p.onBecomeVisible();
        }
    }, [visible, p.onBecomeVisible]);
    return Preact.h(Box_1.default, { ref: updateRef }, p.children);
};
function useVisibility() {
    var _a = Hooks.useState(null), element = _a[0], setElement = _a[1];
    var _b = Hooks.useState(false), visible = _b[0], setVisible = _b[1];
    var observer = Hooks.useMemo(function () {
        var callback = function (entries, _observer) {
            entries.forEach(function (entry) {
                setVisible(entry.isIntersecting);
            });
        };
        return new IntersectionObserver(callback, { root: null, threshold: 0.1 });
    }, []);
    Hooks.useEffect(function () {
        if (!element)
            return;
        observer.observe(element);
        return function () {
            observer.unobserve(element);
        };
    }, [element]);
    var updateRef = Hooks.useCallback(function (e) {
        if (e === null)
            return;
        setElement(e);
    }, []);
    return {
        visible: visible,
        updateRef: updateRef,
    };
}
